import React, { useState, useRef } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, BookOpen, Brain, Radar, Zap, Users, Network } from 'lucide-react';
import { motion } from 'framer-motion';
const includes = [{
  id: 1,
  icon: BookOpen,
  title: 'CÓDIGO ALIMENTARIO',
  subtitle: 'El Sistema Maestro de Intervención',
  color: 'bg-gradient-to-br from-[#2A241B] to-[#1A1610]',
  label: 'Producto Principal'
}, {
  id: 2,
  icon: Brain,
  title: 'NEURO-PANTALLAS',
  subtitle: 'Dopamina digital y alimentación',
  color: 'bg-[#1F5C5C]',
  label: 'Bono #1'
}, {
  id: 3,
  icon: Radar,
  title: 'RADAR ARFID PRO',
  subtitle: 'Screening y diagnóstico diferencial',
  color: 'bg-[#1B3A5C]',
  label: 'Bono #2'
}, {
  id: 4,
  icon: Zap,
  title: "FLASH PLANNER 5'",
  subtitle: 'Organizá tu semana en minutos',
  color: 'bg-[#3B6B4F]',
  label: 'Bono #3'
}, {
  id: 5,
  icon: Users,
  title: 'PARENT COACH PACK',
  subtitle: 'Liderazgo y comunicación familiar',
  color: 'bg-[#4A2C5C]',
  label: 'Bono #4'
}, {
  id: 6,
  icon: Network,
  title: 'MATRIZ DE EXPANSIÓN 360°',
  subtitle: 'Ingeniería de puentes alimentarios',
  color: 'bg-[#8B2A2A]',
  label: 'Bono #5'
}];
export function TomosCarousel() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 280;
    const gap = 24;
    const scrollAmount = cardWidth + gap;
    const newScroll = direction === 'left' ? scrollRef.current.scrollLeft - scrollAmount : scrollRef.current.scrollLeft + scrollAmount;
    scrollRef.current.scrollTo({
      left: newScroll,
      behavior: 'smooth'
    });
  };
  const handleScroll = () => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 280;
    const gap = 24;
    const index = Math.round(scrollRef.current.scrollLeft / (cardWidth + gap));
    setActiveIndex(Math.min(index, includes.length - 1));
  };
  return <section className="bg-surface py-16 px-4 overflow-hidden border-b border-border" data-id="element-245">
      <div className="max-w-6xl mx-auto" data-id="element-246">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-ink text-center mb-10 font-serif" data-id="element-247">
          📚 Todo lo que vas a recibir{' '}
          <span className="text-primary block md:inline mt-2 md:mt-0 text-2xl md:text-3xl" data-id="element-248">
            (Producto Principal + 5 Bonos)
          </span>
        </motion.h2>

        <div className="relative" data-id="element-249">
          <button onClick={() => scroll('left')} className="hidden md:flex absolute -left-6 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-white border border-border rounded-full items-center justify-center text-ink hover:bg-cream transition-colors shadow-md" aria-label="Anterior" data-id="element-250">
            <ChevronLeftIcon className="w-6 h-6" data-id="element-251" />
          </button>
          <button onClick={() => scroll('right')} className="hidden md:flex absolute -right-6 top-1/2 -translate-y-1/2 z-10 w-12 h-12 bg-white border border-border rounded-full items-center justify-center text-ink hover:bg-cream transition-colors shadow-md" aria-label="Siguiente" data-id="element-252">
            <ChevronRightIcon className="w-6 h-6" data-id="element-253" />
          </button>

          <div ref={scrollRef} onScroll={handleScroll} className="flex gap-6 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-8 pt-4 px-4 -mx-4 md:px-0 md:mx-0" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          WebkitOverflowScrolling: 'touch'
        }} data-id="element-254">
            {includes.map((item, index) => <motion.div key={item.id} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.4,
            delay: index * 0.08
          }} viewport={{
            once: true
          }} className="flex-shrink-0 snap-center w-[260px] md:w-[300px]" data-id="element-255">
                <div className={`rounded-lg border-2 border-gold/30 overflow-hidden shadow-[0_10px_30px_rgba(0,0,0,0.15)] transition-transform hover:-translate-y-2 aspect-[3/4] flex flex-col relative ${item.color}`} data-id="element-256">
                  {/* Book spine effect */}
                  <div className="absolute left-0 top-0 bottom-0 w-6 bg-black/20 border-r border-white/10" data-id="element-257"></div>
                  <div className="absolute left-2 top-0 bottom-0 w-px bg-white/20" data-id="element-258"></div>

                  <div className="flex-1 flex flex-col items-center justify-center p-8 text-center relative z-10 ml-4" data-id="element-259">
                    <div className="w-16 h-16 rounded-full border-2 border-gold/50 flex items-center justify-center mb-6 bg-black/20" data-id="element-260">
                      <item.icon className="w-8 h-8 text-gold" data-id="element-261" />
                    </div>
                    <p className="text-gold/80 text-xs font-bold tracking-widest uppercase mb-2 bg-black/30 px-2 py-1 rounded" data-id="element-262">
                      {item.label}
                    </p>
                    <h3 className="text-white text-xl md:text-2xl font-bold leading-tight mb-3 font-serif drop-shadow-md" data-id="element-263">
                      {item.title}
                    </h3>
                    <p className="text-white/80 text-sm font-medium" data-id="element-264">
                      {item.subtitle}
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="flex justify-center gap-2 mt-2" data-id="element-265">
          {includes.map((_, index) => <button key={index} onClick={() => {
          if (!scrollRef.current) return;
          const cardWidth = scrollRef.current.querySelector('div')?.offsetWidth || 280;
          const gap = 24;
          scrollRef.current.scrollTo({
            left: index * (cardWidth + gap),
            behavior: 'smooth'
          });
        }} className={`h-2.5 rounded-full transition-all duration-300 ${index === activeIndex ? 'bg-primary w-8' : 'bg-border hover:bg-primary/50 w-2.5'}`} aria-label={`Ir a item ${index + 1}`} data-id="element-266" />)}
        </div>

        <p className="text-center text-muted text-sm mt-4 md:hidden" data-id="element-267">
          Deslizá para ver todo 👉
        </p>
      </div>
    </section>;
}